import { ScrollArea } from "@/components/ui/scroll-area";
import { RefusedArticle } from "@/interfaces/PartialReception";
import React from "react";
import RefusedArticleCard from "./RefusedArticleCard";

interface RefusedArticleListProps {
  refusedArticles: RefusedArticle[];
  onRemove: (id: string) => void;
  isReadOnly?: boolean;
}

const RefusedArticleList: React.FC<RefusedArticleListProps> = ({
  refusedArticles,
  onRemove,
  isReadOnly,
}) => {
  return (
    <ScrollArea className="h-full" showScrollIndicator>
      {refusedArticles.length === 0 && (
        <div className="text-center text-gray-500 font-sans my-2">
          Aucun article refusé, tous les articles seront acceptés
        </div>
      )}
      {refusedArticles.map((refusedArticle) => (
        <RefusedArticleCard
          key={refusedArticle.id}
          refusedArticle={refusedArticle}
          isReadOnly={isReadOnly}
          onRemove={() => onRemove(refusedArticle.id)}
        />
      ))}
    </ScrollArea>
  );
};

export default RefusedArticleList;
